import React from 'react';
import { Header } from '../components/site/Header';
import { Hero } from '../components/site/Hero';
import { About } from '../components/site/About';
import { Services } from '../components/site/Services';
import { HoneyDoList } from '../components/site/HoneyDoList';
import { Gallery } from '../components/site/Gallery';
import { Testimonials } from '../components/site/Testimonials';
import { QuoteSection } from '../components/site/QuoteSection';
import { Footer } from '../components/site/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-heading text-ink antialiased" data-id="element-260" data-mp="24hk99j4xntnh">
      <Header data-id="element-261" data-mp="29f26ic9l8kfn" />
      <main data-id="element-262" data-mp="29ek4t045pe0c">
        <Hero data-id="element-263" data-mp="29etxivgl5z9q" />
        <About data-id="element-264" data-mp="29ihp3p2h0blt" />
        <Services data-id="element-265" data-mp="2dhgsv6cgu2bo" />
        <HoneyDoList data-id="element-266" data-mp="2dhyvckpq1cs1" />
        <Gallery data-id="element-267" data-mp="2dii6nikv92x3" />
        <Testimonials data-id="element-268" data-mp="2dj1jikvnt149" />
        <QuoteSection data-id="element-269" data-mp="3kvadcpw1yhx4" />
      </main>
      <Footer data-id="element-270" data-mp="3ku8qzp9l6903" />
    </div>;
}